export class ReporteFacturacion {

public   idCompania: string;
public   idVisita: string;
public   idTarea: string;
public   tipoTarea: string;
public   numeroDocumento: string;
public   numeroOrden: string;
public   clasificacion: string;
public   codigo: string;
public   descripcion: string;
public   unidadMedida: string;
public  cantidad: number;
public  cantidadConfirmada: number;

public  peso: number;
public  volumen: number;
public   estadoTarea: string;
public   observaciones: string;

public  fechaInicio: Date;
public fechaFinalizacion: Date;

public nombreUsuario:string;
public idVehiculo:string;
public direccion;
public nombrePunto;

}